import React from "react";

const UserHome = () => (
  <div>
    <p>User home page</p>
  </div>
);

export default UserHome;
